import styled from 'styled-components';

import { Button } from '@xemplo/button';
import { IconButton } from '@xemplo/icon-button';
import {
  BodySmallMedium,
  Colour,
  MinBreakpointV2,
  TextEllipsis,
} from '@xemplo/style-constants';

export const Container = styled.div`
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  background: ${Colour.Gray[100]};
  transition: all 0.1s ease-out;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 16px 24px;
  height: 52px;
  ${BodySmallMedium};
  color: ${Colour.Gray[400]};

  &.has-selected {
    background: ${Colour.Blue[500]};
    color: ${Colour.Light[100]};
  }

  + table {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`;

export const CloseButton = styled(IconButton)`
  margin-left: -8px;
  margin-right: 8px;
`;

export const SelectedActions = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 0px;
  transition: margin-right 0.2s ease-out;

  &.list-table {
    margin-right: 0;
  }

  &.has-selected {
    margin-right: -8px;
    @media ${MinBreakpointV2.medium} {
      margin-right: 0;
    }
  }
`;

export const Divider = styled.div`
  width: 1px;
  height: 16px;
  background: ${Colour.Dark[30]};
  transition: all 0.1s ease-out;
  margin-inline: 12px;

  &.light {
    background: ${Colour.Light[30]};
  }

  @media ${MinBreakpointV2.medium} {
    margin-inline: 24px;
  }
`;

export const Selector = styled.span`
  color: ${Colour.Gray[400]};
  cursor: pointer;
  &:hover {
    color: ${Colour.Gray[700]};
  }
  &.selected {
    color: ${Colour.Light[80]};
    &:hover {
      color: ${Colour.Light[100]};
    }
  }
`;

export const SelectAllButton = styled(Button)`
  flex: 0 1 auto;
  min-width: 0;
  justify-content: flex-start;

  > div {
    display: block;
    min-width: 50px;
    ${TextEllipsis};
  }
`;
